import { api, catchErrorHandler } from "bodycodi/cmap/app/js/api";

export const getAmpmText = (hour) => {
  return hour < 12 ? "오전" : "오후";
};

// in: time: {hour: 1, min: 45}
// out: 오전 1:45
export const getTimeText = (time) => {
  const hour = time.hour < 13 ? time.hour : time.hour - 12;
  const min = addZero(time.min);
  return `${getAmpmText(time.hour)} ${hour}:${min}`;
};

export const recoverTag = (str = "") => {
  return str
    .replace(/\&#60;/g, "<")
    .replace(/\&#62;/g, ">")
    .replace(/\&lt;/g, "<")
    .replace(/\&gt;/g, ">")
    .replace(/\&#47;/g, "/")
    .replace(/&#124;/g, "|");
};

export const replaceTag = (str = "") => {
  return str
    .replace(/\</g, "&#60;")
    .replace(/\>/g, "&#62;")
    .replace(/\//g, "&#47;")
    .replace(/\|/g, "&#124;");
};

export const getUsePeriod = (pass) =>
  pass?.usePeriod + (pass?.usePeriodType === "M" ? "개월" : "일");
export const getUseNumber = (pass) => (pass?.useNumber * 1 > 0 ? pass?.useNumber + "회" : "무제한");

// in: {2023-01-10, 3, "M"} || {2023-01-10, 15, "D"}
// out: 2023-04-10 || 2023-01-25
export const getUseEndDate = (startDate, usePeriod, usePeriodType) => {
  const date = new Date(startDate);
  if (usePeriodType === "M") {
    let year = date.getFullYear();
    let month = date.getMonth() + 1 + usePeriod;
    let day = date.getDate();
    if (month > 12) {
      year = year + 1;
      month = month - 12;
    }
    const febDay = new Date(year, 2, 0).getDate();
    if (month == 2 && day > febDay) date.setDate(febDay + 1);
    date.setMonth(date.getMonth() + usePeriod);
  } else {
    date.setDate(date.getDate() + usePeriod);
  }
  date.setDate(date.getDate() - 1);

  return date.format();
};

// in: {year: 2022, month: 5} 6월임
// out: 5
export const getWeekCnt = (scheduleDate) => {
  const lastDate = new Date(scheduleDate.year, scheduleDate.month + 1, 0).getDate();
  const firstDay = new Date(scheduleDate.year, scheduleDate.month, 1).getDay();
  return Math.ceil((lastDate + firstDay) / 7);
};

// in "2022-06-17 10:15:49"
// out 1분전, 30분 전, 3시간 전, 23시간 전, 어제 ∙ 14:30, 1주전 ∙ 14:30, 2021.8.28 수 ∙ 14:30
export const getAlarmTimeText = (date) => {
  const today = new Date();
  const alarmDate = new Date(date);
  const timeText = `∙${alarmDate.getHours()}:${addZero(alarmDate.getMinutes())}`;
  const dateDiff = Math.round((today.getTime() - alarmDate.getTime()) / (1000 * 60 * 60 * 24));
  if (dateDiff < 1) {
    let hourDiff = today.getHours() - alarmDate.getHours();
    hourDiff = hourDiff < 0 ? hourDiff + 24 : hourDiff;
    if (hourDiff === 1) {
      const minuteDiff =
        today.getHours() * 60 +
        today.getMinutes() -
        (alarmDate.getHours() * 60 + alarmDate.getMinutes());
      if (minuteDiff < 60) {
        return `${minuteDiff}분 전`;
      }
    }
    if (hourDiff === 0) {
      const minuteDiff = today.getMinutes() - alarmDate.getMinutes();
      return `${minuteDiff}분 전`;
    }
    return `${hourDiff}시간 전`;
  }
  if (dateDiff === 1) {
    return `어제${timeText}`;
  }
  if (dateDiff < 7) {
    return `${dateDiff}일 전${timeText}`;
  }
  if (dateDiff === 7) {
    return `1주 전${timeText}`;
  }
  return `${alarmDate.getFullYear()}. ${alarmDate.getMonth() + 1}. ${alarmDate.getDate()}. ${getDwk(
    alarmDate.getDay()
  )}${timeText}`;
};

export const convertTimePicker = (time) => {
  let date;
  if (time.ampm === "AM") {
    date = "" + addZero(time.hour) + ":" + addZero(time.min);
  } else {
    if (time.hour * 1 === 12) {
      date = "12:" + addZero(time.min);
    } else {
      date = "" + addZero(time.hour + 12) + ":" + addZero(time.min);
    }
  }
  return date;
};

export const convertDateTime = (date, time) => {
  let date1 = date.year + "-" + addZero(date.month) + "-" + addZero(date.date);
  let time2 = convertTimePicker(time);
  let time1 = time2 + ":00";

  return date1 + " " + time1;
};

export const findIndex = (list, find) => {
  let index;
  for (let i = 0; i < list.length; i++) {
    if (list[i] === find) {
      index = i;
      break;
    }
  }
  return index;
};

export function locationReplace(url) {
  if (window.history.replaceState) {
    // history의 replaceState 기능이 사용 가능한 경우
    try {
      window.history.replaceState(null, window.document.title, url);
      window.history.go(0);
    } catch (e) {
      window.location.replace(url);
    }
  } else {
    // history의 replaceState 기능이 사용 가능하지 않은 경우
    window.location.replace(url);
  }
}

export function openCommonAlert({ header, body, closeAlert = () => {}, cancelAlert = () => {} }) {
  window.dispatchEvent(
    new CustomEvent("alert", {
      detail: { header: header, body: body, closeAlert: closeAlert, cancelAlert: cancelAlert },
    })
  );
}

export function callApi(url, data, method, loading) {
  return new Promise(function (resolve, reject) {
    if (method === "GET") {
      api
        .get(url, {
          params: data,
        })
        .then(function (response) {
          resolve(response.data);
        })
        .catch((e) => {
          catchErrorHandler(e);
          reject(e.response);
        });
    } else if (method === "POST") {
      api
        .post(url, data)
        .then(function (response) {
          resolve(response.data);
        })
        .catch((e) => {
          catchErrorHandler(e);
          reject(e.response);
        });
    } else if (method === "PATCH") {
      api
        .patch(url, data)
        .then(function (response) {
          resolve(response.data);
        })
        .catch((e) => {
          catchErrorHandler(e);
          reject(e.response);
        });
    }
  });
}

export function setLocalStorage(name, value) {
  localStorage.setItem(name, value);
}

export function getLocalStorage(name) {
  return localStorage.getItem(name);
}

export function deleteLocalStorage(name) {
  localStorage.removeItem(name);
}

export function uploadImg(url, data, method) {
  window.dispatchEvent(new CustomEvent("loading", { detail: { loading: true } }));
  return new Promise((resolve, reject) => {
    api
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 500) {
          reject();
        } else {
          resolve(res.data);
        }
      })
      .finally(() => {
        window.dispatchEvent(new CustomEvent("loading", { detail: { loading: false } }));
      });
  });
}

export function ConvertDateTime(date) {
  return date.split(" ").join("T");
}

export function isEmpty(value) {
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    (value !== null && typeof value === "object" && !Object.keys(value).length)
  ) {
    return true;
  } else {
    return false;
  }
}

export function isToday(t) {
  let date = new Date();
  return (
    date.getFullYear() === t.year && date.getMonth() + 1 === t.month && date.getDate() === t.date
  );
}

export function isTodayObject(t) {
  let date = new Date();
  return (
    date.getFullYear() === t.getFullYear() &&
    date.getMonth() === t.getMonth() &&
    date.getDate() === t.getDate()
  );
}

export function ampm(t) {
  let t1 = t.split(":");
  var ampm = t1[0] * 1 >= 12 ? "오후" : "오전";
  return ampm;
}

export function timeFormat(t) {
  if (!isEmpty(t)) {
    let time;
    const a = ampm(t);
    let ampmEng;
    if (a === "오전") {
      time = t.split(":")[0] * 1 + ":" + addZero(t.split(":")[1]);
      ampmEng = "AM";
    } else {
      let h = t.split(":")[0] * 1;
      if (h !== 12) {
        h = h - 12;
      }
      time = `${h}:${addZero(t.split(":")[1])}`;
      ampmEng = "PM";
    }
    return { ampm: a, time: time, ampmEng: ampmEng };
  }
  return { ampm: "", time: "", ampmEng: "" };
}

export function addZero(i) {
  return i * 1 < 10 ? "0" + i * 1 : i;
}

// in: '2021-06-29'
// out: '2021.6.29' ||  2021. 6. 29
export const changeDateFormat = (date = "2000-01-01", withSpacedDot = false) => {
  let dot = withSpacedDot ? ". " : ".";

  return (
    date.split("-")[0] +
    dot +
    parseInt(date.split("-")[1], 10) * 1 +
    dot +
    parseInt(date.split("-")[2], 10) * 1
  );
};

export function dateFormat({ date = "", formatString = ". " }) {
  let timeRegExp = /^(\d{4})(\d{2})(\d{2})$/;
  return date.toString().replace(timeRegExp, "$1" + formatString + "$2" + formatString + "$3");
}

export function dateFormat2({ date }) {
  let list = date.replace(/-/gi, "");
  return list.substring(0, 4) + "." + list.substring(4, 6) * 1 + "." + list.substring(6, 8) * 1;
}

export function mobileFormat(x) {
  let exp = /^(0[016789][016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{4})-?([0-9]{4})$/;
  return x.toString().replace(exp, "$1-$2-$3");
}

export function numberForamt(x) {
  let exp = /[^0-9]/gi;
  return x.toString().replace(exp, "");
}

export function exceptKorean(x) {
  let exp = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/gi;
  return x.toString().replace(exp, "");
}

export function getOS() {
  let currentOSclcd;

  let mobile = /iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase());

  if (mobile) {
    // 유저에이전트를 불러와서 OS를 구분합니다.
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.search("android") > -1) {
      currentOSclcd = "AD";
    } else if (
      userAgent.search("iphone") > -1 ||
      userAgent.search("ipod") > -1 ||
      userAgent.search("ipad") > -1
    ) {
      currentOSclcd = "IO";
    } else {
      currentOSclcd = "else";
    }
  } else {
    // 모바일이 아닐 때
    currentOSclcd = "nomobile";
  }

  return currentOSclcd;
}

export function serializeObject({ selector = "", element, type = "POST" }) {
  let form;
  let inputs;
  if (!isEmpty(selector)) {
    form = document.querySelector(selector);
    inputs = form.querySelectorAll(selector + " input, select, textarea");
  } else {
    form = element;
    inputs = form.querySelectorAll("input, select, textarea");
  }
  let obj = {};
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    if (!input.disabled) {
      if (!isEmpty(input.name)) {
        if (
          input.type === "text" ||
          input.type === "password" ||
          input.type === "number" ||
          input.type === "hidden" ||
          input.type === "tel"
        ) {
          let list =
            form.querySelectorAll(`[name=${input.name}]:not([disabled]):not([ignore])`).length === 1
              ? false
              : true;
          if (!list) {
            if (input.dataset.type === "List") {
              list = true;
            }
          }
          //let value = input.value.replace(/-|,/gi,"","");
          let value = input.value.replace(/,/gi, "", "");
          if (list) {
            if (obj[input.name]) {
              obj[input.name].push(value);
            } else {
              obj[input.name] = [value];
            }
          } else {
            obj[input.name] = value;
          }
        } else if (input.type === "checkbox") {
          const list =
            form.querySelectorAll(`[name=${input.name}]:not([disabled]):not([ignore])`).length === 1
              ? false
              : true;
          let value = input.checked ? input.value : "";
          if (!isEmpty(input.dataset.uncheckvalue)) {
            if (!input.checked) {
              value = input.dataset.uncheckvalue;
            }
          }
          if (list) {
            if (obj[input.name]) {
              obj[input.name].push(value);
            } else {
              obj[input.name] = [value];
            }
          } else {
            obj[input.name] = value;
          }
        } else if (input.type === "radio") {
          let value = input.checked ? input.value : "";
          if (!isEmpty(input.dataset.uncheckvalue)) {
            if (!input.checked) {
              value = input.dataset.uncheckvalue;
            }
          }
          if (input.checked) {
            obj[input.name] = value;
          } else {
            if (isEmpty(obj[input.name])) {
              obj[input.name] = value;
            }
          }
        } else {
          const list =
            form.querySelectorAll(`[name=${input.name}]:not([disabled])`).length === 1
              ? false
              : true;
          let value = input.value;
          if (list) {
            if (obj[input.name]) {
              obj[input.name].push(value);
            } else {
              obj[input.name] = [value];
            }
          } else {
            obj[input.name] = value;
          }
        }
      }
    }
  }
  if (type === "GET") {
    for (const d in obj) {
      if (Array.isArray(obj[d])) {
        obj[d] = obj[d].join("&");
      }
    }
  }
  return obj;
}

export function deleteAutoLogin() {
  callApi("/cmap1010/execLogout", {}, "POST")
    .then(() => {
      deleteLocalStorage("accessToken");
      deleteLocalStorage("seqMobileMembers");
      deleteLocalStorage("seqManagerMobileDevice");
      locationReplace("/login");
    })
    .catch(() => {
      deleteLocalStorage("accessToken");
      deleteLocalStorage("seqMobileMembers");
      deleteLocalStorage("seqManagerMobileDevice");
      locationReplace("/login");
    });
}

export function removeAccount() {
  callApi("/cmap1010/withdrawal", {}, "POST")
    .then(() => {
      deleteLocalStorage("accessToken");
      deleteLocalStorage("seqMobileMembers");
      deleteLocalStorage("seqManagerMobileDevice");
      locationReplace("/login");
    })
    .catch(() => {
      deleteLocalStorage("accessToken");
      deleteLocalStorage("seqMobileMembers");
      deleteLocalStorage("seqManagerMobileDevice");
      locationReplace("/login");
    });
}

export function deepCopyArray(array) {
  return [...array];
}

export function getDwk(day) {
  const week = ["일", "월", "화", "수", "목", "금", "토", "일"];
  return day != null ? week[day] : "";
}

export function getServiceType(serviceType) {
  let service = "";

  if (serviceType.toLowerCase() === "appointment") {
    service = "개인레슨";
  } else if (serviceType.toLowerCase() === "class") {
    service = "그룹수업";
  } else if (serviceType.toLowerCase() === "option") {
    service = "옵션";
  } else if (serviceType.toLowerCase() === "place") {
    service = "장소";
  }
  return service;
}

export function scrollTo({ element, to, duration }) {
  var start = element.scrollTop,
    change = to - start,
    currentTime = 0,
    increment = 20;

  var animateScroll = function () {
    currentTime += increment;
    var val = Math.easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

export function createMarkup(html) {
  return { __html: html };
}

export function scheduleState(state) {
  let stateNm = "";
  if (state === "E") {
    stateNm = "출석";
  } else if (state === "R") {
    stateNm = "예약";
  } else if (state === "C") {
    stateNm = "취소";
  } else if (state === "A") {
    stateNm = "결석";
  } else if (state === "W") {
    stateNm = "대기";
  } else if (state === "O") {
    stateNm = "폐강";
  }
  return stateNm;
}

export const getPayrollStatus = (state) => {
  switch (state) {
    case "PAYROLL_REQUEST":
      return <span className="check-salary-label requested">승인요청</span>;
    case "PAYROLL_RE_REQUEST":
      return <span className="check-salary-label requested">재승인요청</span>;
    case "PAYROLL_OBJECTION":
      return <span className="check-salary-label objection">이의제기</span>;
    case "PAYROLL_CONFIRMED":
      return <span className="check-salary-label confirmed">확정완료</span>;
  }
};

export function spaceCheck(s) {
  const ex = /^\s+|\s+$/gm;
  return ex.test(s);
}

export function emailCheck(s) {
  //  const ex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  //  return !ex.test(s);
  // os issue blocking
  return false;
}

export function emojiCheck(s) {
  const ex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/gim;
  return !ex.test(s);
}

// in: string😀
// out: string
export function blockEmoji(str) {
  return str.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, "");
}

//t = current time
//b = start value
//c = change in value
//d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

// 마지막글자가 받침으로 끝나는가에 따라 을/를 구분하는 함수
export const endWithConsonant = (text) => {
  const strGa = 44032; // 가
  const strHih = 55203; // 힣

  const lastStrCode = text.charCodeAt(text.length - 1);

  if (lastStrCode < strGa || lastStrCode > strHih) {
    return "를";
  }
  return (lastStrCode - strGa) % 28 == 0 ? "를" : "을";
};

// community detail -> comment date
export const formatCommentDate = (dateToFormat) => {
  let obj = {};
  let date1 = dateToFormat.split(" ")[0];
  let year = date1.split("-")[0];
  let month = date1.split("-")[1];
  let date = date1.split("-")[2];
  let regDt = new Date(ConvertDateTime(dateToFormat));
  let current = new Date();
  let time = timeFormat(dateToFormat.split(" ")[1]);
  let dateFormat1 = dateFormat({
    date: dateToFormat.split(" ")[0].replace(/-/gi, ""),
    formatString: ". ",
  });
  let dwk = getDwk(regDt.getDay());
  let timeText = ``;

  let sec = Math.floor((current.getTime() - regDt.getTime()) / 1000);
  let min = Math.floor((current.getTime() - regDt.getTime()) / 1000 / 60);
  let hour = Math.floor((current.getTime() - regDt.getTime()) / 1000 / 60 / 60);
  let dt = Math.floor((current.getTime() - regDt.getTime()) / 1000 / 60 / 60 / 24);
  if (sec < 60) {
    timeText = `방금`;
  } else if (min < 60) {
    timeText = `${min}분전`;
  } else if (hour < 24) {
    timeText = `${hour}시간 전`;
  } else if (dt <= 7) {
    if (dt === 1) {
      timeText = `어제 <span className="dot">&#183;</span> ${time.ampm} ${time.time}`;
    } else if (dt === 7) {
      timeText = `1주 전 <span className="dot">&#183;</span> ${time.ampm} ${time.time}`;
    } else {
      timeText = `${dt}일 전 <span className="dot">&#183;</span> ${time.ampm} ${time.time}`;
    }
  } else {
    timeText = `${dateFormat1} ${dwk} <span className="dot">&#183;</span> ${time.ampm} ${time.time}`;
  }
  let currentDate =
    current.getFullYear() + "" + addZero(current.getMonth() + 1) + "" + addZero(current.getDate());
  if (currentDate === dateToFormat.substring(0, 8)) {
    obj.current = true;
  } else {
    obj.current = false;
  }
  obj.date = year + ". " + month * 1 + ". " + addZero(date * 1) + ". " + getDwk(regDt.getDay());
  obj.timeText = timeText;
  return obj;
};

export const consumedAppointmentPassCnt = (
  numberPassYn,
  voucherMinusYn,
  lessonAmount,
  from,
  to
) => {
  if (numberPassYn === "N") {
    return 1000;
  }
  if (numberPassYn === "Y") {
    if (to === "E") {
      return lessonAmount * -1;
    }
    if (to === "A") {
      if (voucherMinusYn === "Y" && from === "R") {
        return lessonAmount * -1;
      }
      if (voucherMinusYn === "Y" && from === "E") {
        return 0;
      }
      if (voucherMinusYn === "Y" && from === "S") {
        return lessonAmount * -1;
      }
      if (voucherMinusYn === "N" && from === "R") {
        return 0;
      }
      if (voucherMinusYn === "N" && from === "E") {
        return 1;
      }
      if (voucherMinusYn === "N" && from === "S") {
        return 0;
      }
    }
  }
  return 1000;
};

export const getYoutubeUrl = (url) => {
  if (url.includes("https://youtu.be")) {
    return url.split("?")[0];
  }
  if (url.includes("?")) {
    const queryString = url.split("?")[1];
    const params = new URLSearchParams(queryString);
    const v = params.get("v");
    return `https://youtu.be/${v}`;
  } else {
    return url;
  }
};

export const getSnsCode = (link) => {
  if (link.includes("facebook")) return "FACEBOOK";
  if (link.includes("instagram")) return "INSTAGRAM";
  if (link.includes("youtube") || link.includes("youtu.be")) return "YOUTUBE";
};

// in: 010-0000-0000
// out: 010-****-0000
export const maskingMobile = (mobile) => {
  if (!mobile) return "";
  return `${mobile.substring(0, 3)}-****-${mobile.substring(9)}`;
};

// money format
export const moneyFormatter = (value, withoutSign = false) => {
  const formatter = new Intl.NumberFormat("ko-KR");

  if (!value) return "0원";

  if (withoutSign) return formatter.format(value);

  return formatter.format(value) + "원";
};

// in: 20000, "이상" | "이하"
// out: 20,000원 이상 | ~ 이하
export const contractTableMoneyFormat = (amount, postfix = "") => {
  if (amount === null || amount === undefined) return "";

  return postfix === "이상"
    ? moneyFormatter(amount) + " " + postfix
    : "~ " + moneyFormatter(amount) + postfix;
};

export function getTotalFoodDetail(arr) {
  return arr.reduce(
    (prev, curr) => {
      return {
        calories: prev.calories + Math.round(curr?.nutrition?.calories * curr.eatAmount),
        totalgram: Number(
          (prev.totalgram + curr?.nutrition?.totalgram * curr.eatAmount).toFixed(1)
        ),
        fat: Number((prev.fat + curr?.nutrition?.fat * curr.eatAmount).toFixed(1)),
        saturatedfat: Number(
          (prev.saturatedfat + curr?.nutrition?.saturatedfat * curr.eatAmount).toFixed(1)
        ),
        transfat: Number((prev.transfat + curr?.nutrition?.transfat * curr.eatAmount).toFixed(1)),
        cholesterol: Number(
          (prev.cholesterol + curr?.nutrition?.cholesterol * curr.eatAmount).toFixed(1)
        ),
        sodium: Number((prev.sodium + curr?.nutrition?.sodium * curr.eatAmount).toFixed(1)),
        carbonhydrate: Number(
          (prev.carbonhydrate + curr?.nutrition?.carbonhydrate * curr.eatAmount).toFixed(1)
        ),
        protein: Number((prev.protein + curr?.nutrition?.protein * curr.eatAmount).toFixed(1)),
        sugar: Number((prev.sugar + curr?.nutrition?.sugar * curr.eatAmount).toFixed(1)),
      };
    },
    {
      calories: 0,
      totalgram: 0,
      fat: 0,
      saturatedfat: 0,
      transfat: 0,
      cholesterol: 0,
      sodium: 0,
      carbonhydrate: 0,
      protein: 0,
      sugar: 0,
    }
  );
}

// in: 120(분)
// out: 2시간
export const convertMinutes = (time) => {
  const days = Math.floor(time / (24 * 60));
  const hours = Math.floor((time % (24 * 60)) / 60);
  const minutes = Math.floor(time % 60);

  // Format the remaining time
  let formattedTime = "";

  if (days > 0) {
    formattedTime += `${days} 일 `;
  }
  if (hours > 0) {
    formattedTime += `${hours} 시간 `;
  }
  if (minutes > 0) {
    formattedTime += `${minutes} 분`;
  }

  return formattedTime;
};
